import { render, staticRenderFns } from "./ModalViewPhoto.vue?vue&type=template&id=8ec46042"
import script from "./ModalViewPhoto.vue?vue&type=script&lang=js"
export * from "./ModalViewPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports